import {
  PAGE_LOGIN,
  PAGE_MICRO,
  PAGE_PAGES,
  PAGE_SELECT_CHANNEL,
  usePath,
} from '@frontend/sorghum/utils';
import { useEffect } from 'react';
import { useGetAccountInfo } from '../useGetAccountInfo/useGetAccountInfo';

export const useAuth = () => {
  const token = localStorage.getItem('token');
  const { data: account, refetch } = useGetAccountInfo();
  const { navigate } = usePath();

  useEffect(() => {
    if (!token) {
      navigate(PAGE_LOGIN);
    } else if (account?.step === 'question') {
      navigate(PAGE_MICRO);
    } else if (account?.step === 'choose_project') {
      navigate(PAGE_SELECT_CHANNEL);
    } else if (account?.step === 'fb_connect') {
      navigate(PAGE_PAGES);
    } else {
      refetch();
    }
  }, [token, account, navigate, refetch]);
};
